function CheckoutProduct(props) {
  const { productCost, quantity, size, productName, thumbnail, design } = props.product;

  return (
    <div className={`product-row ${props.success && "success"}`}>
      <div className="product-image">
        <picture>
          <source srcSet={thumbnail} type="image/avif" />
          <img src={thumbnail} width="140" />
        </picture>
      </div>
      <div className="product-block">
        <h2>{productName}</h2>
        <div className="product-block-row">
          <span className="product-block-label">Design</span>
          <strong className="product-block-value">{design}</strong>
        </div>
        <div className="product-block-row">
          <span className="product-block-label">Size</span>
          <strong className="product-block-value">{size}</strong>
        </div>
        <div className="product-block-row">
          <span className="product-block-label">Price</span>
          <strong className="product-block-value">${productCost / 100}</strong>
        </div>
        <div className="product-block-row">
          <span className="product-block-label">Qty</span>
          <strong className="product-block-value">{quantity}</strong>
        </div>
      </div>
    </div>
  );
}

export default CheckoutProduct;
